import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Link } from "react-router-dom";

import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import PlaceholderIMG from "../../../sharedComponents/placeholderImage";
import ConfirmDelete from "../../../sharedComponents/confirmDelete";
import { resetField, getMyWorkouts, deleteExerciseFromPlan, deleteMyWorkouts } from "../../../store/actions";
import Tooltip from "../../../sharedComponents/tooltip";
import AddExercises from "./addExercises";
import EditExercise from "./editExercise";

export const MyWorkout = ({ history, exercises, resetField, getMyWorkouts, deleteExerciseFromPlan, deleteMyWorkouts }) => {
	const [editFormValues, setEditFormValue] = useState({});
	const [deleteItem, setDeleteItem] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [isMyWorkoutList] = useState(true);

	useEffect(() => {
		getMyWorkouts();
	}, [getMyWorkouts]);

	const handleEditExercise = (data) => {
		resetField("MyWorkout.toggleEditPanel", true);
		const newData = {
			...data,
			monday: data.monday ? data.monday : 0,
			tuesday: data.tuesday ? data.tuesday : 0,
			wednesday: data.wednesday ? data.wednesday : 0,
			thursday: data.thursday ? data.thursday : 0,
			friday: data.friday ? data.friday : 0,
			saturday: data.saturday ? data.saturday : 0,
			sunday: data.sunday ? data.sunday : 0
		};
		setEditFormValue(newData);
	};

	const handleDeleteExercise = (data) => {
		setDeleteItem(data);
	};

	const confirmEvent = (yes) => {
		const successHandler = () => {
			getMyWorkouts();
		};
		if (yes && deleteItem) {
			deleteExerciseFromPlan(deleteItem, successHandler);
		}
		if (yes && showModal) {
			deleteMyWorkouts(successHandler);
		}
		setDeleteItem(null);
		setShowModal(false);
	};

	const columns = [
		{
			Header: "#",
			accessor: "main_image.data",
			sortable: false,
			Cell: ({ original }) => (
				<PlaceholderIMG
					src={get(original, "exercise_data.main_image.data", "")}
					width="60"
					height="40"
					bg="rgba(0,0,0,0.1)"
					alt={original.exercise_data.name}
					color="rgba(0,0,0,0.3)"
					objectFit="cover"
				/>
			)
		},
		{
			Header: "Exercise",
			accessor: "exercise_data.name",
			sortable: false,
			width: 300,
			Cell: ({ original }) => (
				<Link to={`/fitness/exercises/${original.exercise_data.id}/details`}>
					{original.exercise_data.name ? original.exercise_data.name : " - "}
				</Link>
			)
		},
		{
			Header: "Monday",
			accessor: "monday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.monday ? original.monday : " - "}</span>
		},
		{
			Header: "Tuesday",
			accessor: "tuesday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.tuesday ? original.tuesday : " - "}</span>
		},
		{
			Header: "Wednesday",
			accessor: "wednesday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.wednesday ? original.wednesday : " - "}</span>
		},
		{
			Header: "Thursday",
			accessor: "thursday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.thursday ? original.thursday : " - "}</span>
		},
		{
			Header: "Friday",
			accessor: "friday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.friday ? original.friday : " - "}</span>
		},
		{
			Header: "Saturday",
			accessor: "saturday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.saturday ? original.saturday : " - "}</span>
		},
		{
			Header: "Sunday",
			accessor: "sunday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.sunday ? original.sunday : " - "}</span>
		},
		{
			Header: "Actions",
			accessor: "id",
			sortable: false,
			className: "text-right",
			headerClassName: "text-right",
			Cell: ({ original }) => (
				<div>
					<Tooltip content="Edit" placement="left">
						<button
							className="btn btn-success btn-ghost btn-cell btn-sm mr-2"
							onClick={() => handleEditExercise(original)}>
							<i className="icon icon-edit" />
						</button>
					</Tooltip>
					<Tooltip content="Delete" placement="left">
						<button
							className="btn btn-danger btn-ghost btn-cell btn-sm"
							onClick={() => handleDeleteExercise(original)}>
							<i className="icon icon-trash" />
						</button>
					</Tooltip>
				</div>
			)
		}
	];

	return (
		<div className="page page-my-workout-listing">
			<div className="container myWorkoutPlan mb-5">
				<div className="d-flex flex-row justify-content-between">
					<h3>Manage My Custom Workout Plan</h3>
					{exercises && exercises.length ? (
						<button className="btn btn-primary-dark btn-ghost ml-3 align-top" onClick={() => setShowModal(true)}>
							<i className="icon icon-trash" /> Remove all
						</button>
					) : null}
				</div>
				<PaginatedTable
					data={exercises ? exercises : []}
					columns={columns}
					pageSize={exercises ? exercises.length : 0}
				/>
			</div>
			<AddExercises history={history} isMyWorkoutList={isMyWorkoutList} />
			{editFormValues && editFormValues.id && <EditExercise initialValues={editFormValues} />}
			<ConfirmDelete
				item={deleteItem ? deleteItem : showModal}
				message={<div>Are you sure you want to delete?</div>}
				onEvent={confirmEvent}
			/>
		</div>
	);
};

const mapDispatchToProps = { resetField, getMyWorkouts, deleteExerciseFromPlan, deleteMyWorkouts };

const mapStateToProps = (state) => {
	const { MyWorkout } = state;
	return {
		exercises: get(MyWorkout, "myWorkoutList.results", []),
		toggleEditPanel: get(MyWorkout, "toggleEditPanel")
	};
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MyWorkout);
